import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import WhatsappSessionPreview from './WhatsappSessionPreview'
import WhatsappTemplatePreview from './WhatsappTemplatePreview'
import { Helper } from '../helpers/Helper'
import { getWaContentIdFromIType } from '../../screens/admin/cdp/WhatsappUtils'

function EmptyPhonePreview() {
  return <WhatsappTemplatePreview components={[]} hideMessageBubble />
}

function OverlayPhonePreview({ message }) {
  return (
    <div className={css(Styles.overlayWrap)}>
      <WhatsappTemplatePreview components={[]} hideMessageBubble />
      <div className={css(Styles.overlay)}>
        <span className={css(Styles.overlayText)}>{message}</span>
      </div>
    </div>
  )
}

export default function WhatsappSendContentPreviewAdapter({ formData, context }) {
  const selected = formData && formData.waMessageId
  const contentId = getWaContentIdFromIType(selected)
  if (!contentId) {
    return (
      <OverlayPhonePreview
        message={Helper.getString(selected ? 'waPreviewNotAvailable' : 'waPreviewPickMessage')}
      />
    )
  }

  const byId = context && context.formDefinition && context.formDefinition.waContentPreviewById
  const entry = byId && byId[contentId]
  if (!entry) return <EmptyPhonePreview />

  if (entry.kind === 'session') {
    const session = (entry.content && typeof entry.content === 'object') ? entry.content : {}
    return <WhatsappSessionPreview formData={session} context={context} />
  }

  const components = Array.isArray(entry.previewComponents) ? entry.previewComponents : []
  return <WhatsappTemplatePreview components={components} />
}

const Styles = StyleSheet.create({
  overlayWrap: {
    position: 'relative',
    width: 340,
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    padding: 20,
  },
  overlayText: {
    color: '#111b21',
    fontSize: 15,
    fontWeight: 600,
    textAlign: 'center',
    lineHeight: 1.4,
  },
})
